// extracted by mini-css-extract-plugin
module.exports =  {"filter":"WP60rQuy6CUkHNVra8oT"};